import "@/App.css";
import { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import api from "@/lib/api";
import Seo from "@/components/Seo";
import { NOT_FOUND_PAGE, seoPage } from "@/lib/seoPages";

function RouteSeo() {
  const location = useLocation();
  // Les pages produit gèrent leur propre SEO (titre, description, JSON-LD)
  if (location.pathname.startsWith("/boutique/")) return null;
  const path = location.pathname.replace(/\/+$/, "") || "/";
  const seo = seoPage(path) || NOT_FOUND_PAGE;
  return <Seo title={seo.title} description={seo.description} path={path} noindex={seo.noindex || false} />;
}
import { AuthProvider } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/Navbar";
import CartDrawer from "@/components/CartDrawer";
import CookieBanner from "@/components/CookieBanner";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Shop from "@/pages/Shop";
import ProductDetail from "@/pages/ProductDetail";
import Rosters from "@/pages/Rosters";
import Results from "@/pages/Results";
import News from "@/pages/News";
import Partners from "@/pages/Partners";
import AdminLogin from "@/pages/AdminLogin";
import AdminActivate from "@/pages/AdminActivate";
import AdminResetPassword from "@/pages/AdminResetPassword";
import AdminDashboard from "@/pages/AdminDashboard";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import Contact from "@/pages/Contact";
import Faq from "@/pages/Faq";
import LegalPage from "@/pages/Legal";
import MyOrders from "@/pages/MyOrders";
import NotFound from "@/pages/NotFound";
import Drafter from "@/pages/Drafter";
import DraftRoom from "@/pages/DraftRoom";

function AppContent() {
  return (
    <>
      <Navbar />
      <CartDrawer />
      <CookieBanner />
      <main className="flex-1">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/boutique" element={<Shop />} />
          <Route path="/boutique/:slug" element={<ProductDetail />} />
          <Route path="/rosters" element={<Rosters />} />
          <Route path="/resultats" element={<Results />} />
          <Route path="/actualites" element={<News />} />
          <Route path="/partenaires" element={<Partners />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/mes-commandes" element={<MyOrders />} />
          <Route path="/faq" element={<Faq />} />
          <Route path="/drafter" element={<Drafter />} />
          <Route path="/drafter/local/:id" element={<DraftRoom local />} />
          <Route path="/drafter/:id" element={<DraftRoom />} />
          <Route path="/mentions-legales" element={<LegalPage docKey="mentions_legales" title="Mentions légales" subtitle="Informations légales" />} />
          <Route path="/cgv" element={<LegalPage docKey="cgv" title="Conditions Générales de Vente" subtitle="Conditions de vente" />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/activer" element={<AdminActivate />} />
          <Route path="/admin/reinitialiser" element={<AdminResetPassword />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/paiement/succes" element={<PaymentSuccess />} />
          <Route path="/paiement/annule" element={<PaymentCancel />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      <Footer />
    </>
  );
}

function App() {
  const [theme, setTheme] = useState({});

  useEffect(() => {
    api.get("/theme").then((r) => setTheme(r.data)).catch(() => {});
  }, []);

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let frame;
    const raf = (time) => {
      lenis.raf(time);
      frame = requestAnimationFrame(raf);
    };
    frame = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(frame);
      lenis.destroy();
    };
  }, []);

  return (
    <div className={`flex min-h-screen flex-col ${theme.bg_image ? "" : "bg-[#060B18]"}`}>
      {theme.bg_image && (
        <img src={theme.bg_image} alt="" className="pointer-events-none fixed inset-0 -z-10 h-full w-full object-cover opacity-[0.08]" />
      )}
      <BrowserRouter>
        <RouteSeo />
        <AuthProvider>
          <CartProvider>
            <AppContent />
            <Toaster theme="dark" position="top-center" richColors />
          </CartProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
